import type { RelativeTimeRangeOffset } from './infinite-axis/types';

export const getTodayColumnIndex = <T extends RelativeTimeRangeOffset>(ranges: T[]) =>
	ranges.findIndex(({ from, to }) => from <= 0 && to > 0);
